import React from 'react';
import clsx from 'clsx';
import { Box, Alert as MaterialAlert, AlertColor } from '@mui/material';
import { WarningSharp, Error, CheckCircle } from '@mui/icons-material';
import { useStyles } from './alert.styles';

export type Props = {
  withIcon?: boolean;
  fullWidth?: boolean;
  color?: AlertColor;
  title?: string | JSX.Element;
  desc: string | JSX.Element;
  classes?: any;
  alertClasses?: string;
};

const icons = {
  success: CheckCircle,
  // EventBusySharp was previously used here
  warning: WarningSharp,
  error: Error,
};

export const Alert: React.FC<Props> = ({
  withIcon = true,
  fullWidth,
  color = 'warning',
  title,
  desc,
  classes,
  alertClasses,
}) => {
  const { classes: styles } = useStyles({ color, fullWidth });

  const IconComp = icons[color];

  const Icon = () => <Box className={styles.iconContaier}>{IconComp && <IconComp />}</Box>;

  return (
    <Box mt={1.5} className={classes?.root}>
      <MaterialAlert severity={color} icon={withIcon ? <Icon /> : false} className={clsx(styles.alert, alertClasses)}>
        {title && (
          <Box className={styles.alertTitle} mb={0.5}>
            {title}
          </Box>
        )}

        <Box className={styles.alertDesc}>{desc}</Box>
      </MaterialAlert>
    </Box>
  );
};
